import Image from "next/image"
import React, {useContext} from "react"
import {filterUrl} from "../filter/FilterUrl"
import urlParams from "../../utility/UrlParams"
import Button from "../reusable/components/Button"
import {useTranslation} from "next-i18next"
import ReusableTitleDescription from "./components/ReusableTitleDescription"
import {useRouter} from "next/router"
import {CollectionName} from "../../constants"
import DataContext from "../../context/DataContext"
import {formatImageSrc} from "../../strapi/strapiHelpers"

function BrandWorldHeroSection() {
	const {t} = useTranslation()
	const {brandWorld} = useContext(DataContext)
	const router = useRouter()
	const {brand} = router.query
	const isShowRoomPage = brand === "mybikeplan"

	return (
		<div
			className="container d-flex gap-4 align-items-center justify-content-center flex-column">
			{!isShowRoomPage && <>
				<div className="d-md-block d-none">{brandWorld?.brandLogo?.data?.attributes.url ? <Image
					src={formatImageSrc(brandWorld?.brandLogo?.data?.attributes.url)}
					width={500}
					height={99} /> : null}</div>

				<div className="d-md-none"
				>
					{brandWorld?.brandLogo.data?.attributes.url ? <Image
						src={formatImageSrc(brandWorld?.brandLogo.data?.attributes.url)}
						layout="fixed"
						width={272}
						height={54} /> : null}</div>
			</>}
			<ReusableTitleDescription title={brandWorld?.heroSectionTitle}
				description={brandWorld.heroSectionDescription} />
			<Button onClick={() => {
				router.push(`${filterUrl({[urlParams.brand]: brandWorld.brandSlug}, urlParams.brand, brandWorld.brandSlug, CollectionName.BrandWorld, CollectionName.BrandWorld, brandWorld.brandSlug)}#products-listing`, null, {shallow: true})
			}}
			label={t(brandWorld.ctaBtnText)}
			style={{marginTop: "1rem"}}
			fontSizeSmall
			textColor="#fff"
			bgColor={brandWorld.buttonsBackgroundColor} />
		</div>
	)
}

export default BrandWorldHeroSection
